export default {
    logs: {
        fields: {
            number: '№',
            dateTime: 'Date and time',
            old: 'Old value',
            'new': 'New value',
            userName: 'Login',
        },
        system: 'system',

        index: 'Event history',
    },

    block: 'Events',

    cancel: 'Are you sure you want to cancel {event}?',
    done: 'Are you sure you want to complete {event}?',

    errorMessage: 'Detailed description of the error',

    fields: {
        orderId: 'Order number',
        handler: 'Event type',
        type: 'From where caused',
        createdAt: 'Created',
        updatedAt: 'Updated',
        data: 'Message',
    },

    list: 'Automatic updating of the list is started',

    restart: 'Are you sure you want to restart {event}?',
    event: 'events | the event',

    actions: 'The action will take place if it is possible with the event!',

    checkAll: 'Select all events on the current page',
};